import { createReducer, createAction } from "redux-act";
import { ThemeName } from "@evergis/ui";

import { reducerRegistry } from "../reducerRegistry";

export const reducerName = "theme";

export type ThemeState = {
  themeName?: ThemeName;
};

const initialState: ThemeState = {
  themeName: ThemeName.Light,
};

export const changeThemeName = createAction<ThemeName>(`${reducerName}/change-theme-name`);

export const reducer = createReducer({}, initialState);

reducer.on(changeThemeName, (state, themeName) => ({ ...state, themeName }));

reducerRegistry.register(reducerName, reducer);
